export default __webpack_public_path__ + "static/menu-dont-dark-d3e3b1d77f3f3208cd22661d9a600a9a.png";